<template>
  <div class="menu-wrapper">
    <div class="sm-md"></div>

    <div class="menu-bar">

      <!-- TODO: Lang change -->
      <!--<div class="lang-box pure-g">-->
        <!--<div v-for="lang in $langs" :class="['lang-co', 'pure-u-1-5', ('lang-' + lang)]"-->
             <!--v-touch:tap="changeLang(lang)"-->
        <!--&gt;{{ lang }}</div>-->
      <!--</div>-->
      <!-- TODO: Remove later -->

      <div class="back-wrapper">
        <router-link :to="{ path: '/' }">
          <div class="titel-menu"></div>
        </router-link>
      </div>
      <div v-if="showMenu" class="burger-wrapper">
        <div v-show="showMenu" :class="['burger-menu', {'open': menuOpened}]" v-touch:tap="toggleMenu">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </div>

    <transition name="slide">
      <div v-if="menuOpened" class="bm-wrapper">
          <div v-for="menu in menuCleaned" :class="['bm-option', {'selected': (currentPageName === menu.name)}]">
            <router-link v-if="(menu.ref === '/lobby')" :to="{ path: (menu.ref + extraPath)}" class="router-link-active">
              <div class="bm-btn-wrapper">
                <h3>{{ $lang.menuoptions[menu.name] }}</h3>
              </div>
            </router-link>
            <router-link v-else :to="{ path: menu.ref}" class="router-link-active">
              <div class="bm-btn-wrapper">
                <h3>{{ $lang.menuoptions[menu.name] }}</h3>
              </div>
            </router-link>
          </div>
      </div>
    </transition>

  </div>
</template>
<script>
import Option from '../../components/menu-options/'
import Context from '../../assets/data/context.json'
import MenuOptions from '../../assets/data/menuoptions.json'
import Options from '../../assets/data/staticdata.json'

export default {
  name: 'menu-co',
  data () {
    return {
      showMenu: true,
      menuOpened: false,
      menuoptions: MenuOptions.menuoptions,
      options: Options,
      currentPageName: '',
      context: Context,
      showDone: false,
      extraPath: ''
    }
  },
  props: {
    text: {
      type: String,
      default: ''
    },
    checked: {
      type: Boolean,
      default: false
    }
  },
  beforeMount () {
    let path = this.$route.path

    if ((path.indexOf('/lobby/') > -1)) {
      path = (path.split('/')[1])
    }

    this.extraPath = '/' + this.store.getItemOrDefault(this.context.current_context, 'transport')

    switch (path) {
      case '/home':
        this.currentPageName = 'mo1'
        break
      case 'lobby':
        this.currentPageName = 'mo2'
        break
      case '/case-progress':
        this.currentPageName = 'mo3'
        break
      case '/done':
        this.currentPageName = 'mo4'
        break
    }

    if (this.showMenu) {
      this.showDone = this.allCasesDone()
    }
  },
  mounted () {
    if (this.$route.path === '/') {
      this.showMenu = false
    }
    this.$bus.$on('MENU-OPTION-CLICKED', () => {
      if (this.menuOpened) {
        this.menuOpened = false
      }
    })
  },
  computed: {
    getPage () {
      return this.$route.name
    },
    menuCleaned: function () {
      let self = this
      return this.menuoptions.filter(function (obj) {
        if (obj.ref !== '/done' || (obj.ref === '/done' && self.showDone)) {
          return obj
        }
      })
    }
  },
  methods: {
    changeLang (lang) {
      let self = this
      return () => {
        self.onChangeLang(lang)
      }
    },
    onChangeLang (lang) { // TODO: Remove Later
      if (this.$lang.currentLang === undefined || this.$lang.currentLang !== lang) {
        this.$setLang(lang)
      }
    },
    allCasesDone () {
      let currCon = this.store.getItemOrFalse(this.context.current_context)
      if (currCon) {
        let doneLength = this.options.caselists[currCon].length
        let prog = this.store.getItem(this.context.current_progress)
        let progLength = prog[currCon].length

        return progLength >= doneLength
      }
      return false
    },
    toggleMenu () {
      this.menuOpened = !this.menuOpened
    }
  },
  components: {
    'menu-option': Option
  }
}
</script>



// WEBPACK FOOTER //
// src/components/menu/index.vue